import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
// Icons
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";

const useStyles = makeStyles(theme => ({
	infoButton: {
		padding: 4
	},
	infoButtonSmall: {
		padding: 2,
		marginLeft: -24,
		marginTop:-2
	},
	infoIcon: {
		width: 20,
		height: 20
	},
	infoIconSmall: {
		width: 18,
		height: 18
	}
}));

const HtmlTooltip = withStyles(theme => ({
	tooltip: {
		backgroundColor: "#fff",
		color: "rgba(0, 0, 0, 0.87)",
		fontSize: theme.typography.pxToRem(14),
		border: "1px solid #dadde9",
		whiteSpace:"pre-wrap"
	}
}))(Tooltip);

export default function InfoTooltip({ content,variant="normal" }) {
	const classes = useStyles();

	return (
		<HtmlTooltip title={content} >
			<IconButton className={variant==="small"?classes.infoButtonSmall:classes.infoButton}>
				<HelpOutlineIcon className={variant==="small"?classes.infoIconSmall:classes.infoIcon} color="secondary" />
			</IconButton>
		</HtmlTooltip>
	);
}
